var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listView"},[_c('h1',{staticClass:"listName"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.errorCode)?_c('p',{staticClass:"errorMessage"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }